import { useTweaks } from '../components/Tweaks.jsx';
import { Header } from '../components/Header.jsx';
import { ForumEmbed } from '../components/Forum.jsx';

const TWEAK_DEFAULTS = {
  navWelshResources: 'Welsh Resources',
  navAboutUs: 'About us',
  navCommunity: 'Community',
  navContact: 'Contact',
  startLearning: 'Start Learning',
};

const GROUPS = [
  { name: 'Header', keys: ['navWelshResources','navAboutUs','navCommunity','navContact','startLearning'] },
];

// Forum route is a flex column: header + iframe wrapper, no footer. The
// iframe fills the remaining viewport so the embedded Discourse always has
// its own scroll context.
export default function Forum() {
  const { tweaks, panel } = useTweaks({ defaults: TWEAK_DEFAULTS, groups: GROUPS });
  return (
    <div data-screen-label="Forum" style={{display:'flex', flexDirection:'column', minHeight:'100vh'}}>
      <Header t={tweaks}/>
      <ForumEmbed/>
      {panel}
    </div>
  );
}
